// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ButtonPresentationProps } from "@insite/mobius/Button";
import { IconPresentationProps, IconWrapper } from "@insite/mobius/Icon";
import CaretRight from "@werner/XDL/Icons/CaretRight";
import Trash from "@werner/XDL/Icons/Trash";
import { color } from "@werner/XDL/Utilities";
import { css } from "styled-components";

interface ButtonsSharedStyles {
    linkButtonWithCaretRight?: ButtonPresentationProps;
    removeIcon?: IconPresentationProps;
}

export const xButtonSharedStyles: ButtonsSharedStyles = {
    linkButtonWithCaretRight: {
        variant: "tertiary",
        sizeVariant: "large",
        typographyProps: {
            size: 16,
            lineHeight: "18px",
            weight: 500,
            color: "common.ui3",
        },
        icon: {
            src: CaretRight,
            position: "right",
        },
        css: css`
            ${IconWrapper} {
                width: 12px;
                height: 12px;
                margin-left: 4px;
                top: 0;
            }
        `,
        mergeCss: true,
    },

    removeIcon: {
        src: Trash,
        css: css`
            display: flex;
            cursor: pointer;
            margin: auto;
            &:hover {
                svg {
                    color: ${color("primary")};
                }
            }
        `,
    },
};
